import { ReactNode } from "react";
import { MouseEvent } from "react";

export enum ButtonVariant {
  Flat = "flat",
  FlatNoFill = "flat-no-fill",
  FlatNoBorder = "flat-no-border",
}

interface ButtonProps {
  variant: typeof ButtonVariant[keyof typeof ButtonVariant];
  disabled?: boolean | undefined;
  selected?: boolean | undefined;
  icon?: ReactNode;
  size?: "sm" | "md" | "lg";
  hideLabelResponsively?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  tabIndex?: number;
}

function Button(props: ButtonProps) {

  const getSizeStyling = () => {
    switch(props.size) {
      case "sm": {
        return "w-7 h-7";
      }
      case "lg": {
        return "w-10 h-10";
      }
      case "md":
      default: {
        return "w-8 h-8";
      }
    }
  };

  const getVariantStyling = () => {
    switch(props.variant) {
        case ButtonVariant.Flat: {
          const base = "bg-palette-1 text-palette-5 rounded-full hover:bg-palette-2 transition duration-300";
          const hover = "hover:bg-palette-2 transition duration-300";
          const disabled = "disabled:bg-palette-4 disabled:text-palette-5";
          return `${base} ${hover} ${disabled}`;
        }
        case ButtonVariant.FlatNoBorder: {
          return "text-palette-3 disabled:bg-palette-4 disabled:text-palette-5 hover:bg-palette-2 transition duration-300";
        }
        case ButtonVariant.FlatNoFill: {
          const base = "rounded-full outline outline-1";
          const hover = props.disabled ? "" : "hover:text-palette-1 hover:outline-palette-1";
          const focus = "focus:text-palette-2 focus:outline-palette-2";
          const disabled = "disabled:outline-palette-3 disabled:text-palette-3";
          const selected = props.selected ? "outline-palette-1 text-palette-1" : "outline-palette-4 text-palette-4";
          return `${base} ${hover} ${focus} ${disabled} ${selected}`;
        }
    }
  };

  return (
    <div>
      <button
        className={`flex items-center justify-center ${getSizeStyling()} ${getVariantStyling()}`}
        onClick={props.onClick}
        disabled={props.disabled}
      >
      {props.icon ? props.icon : null}
      </button>
    </div>
  );
};

export default Button;
